import React from 'react';
import styled from 'styled-components';
import ScrollReveal from './shared/ScrollReveal';

const Section = styled.section`
  padding: 48px 24px 64px;
  max-width: 960px;
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 32px 16px 48px;
  }
`;

const Bar = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1px;
  background: var(--tz-wash, rgba(255, 255, 255, 0.04));
  border: 1px solid var(--tz-wash, rgba(255, 255, 255, 0.04));
  border-radius: 12px;
  overflow: hidden;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

const Item = styled.div`
  background: ${p => p.theme.bg};
  padding: 20px 16px;
  text-align: center;
`;

const ItemLabel = styled.div`
  font-size: 14px;
  color: ${p => p.theme.textSecondary};
  line-height: 1.4;
`;

const ItemAccent = styled.span`
  color: ${p => p.theme.accent};
`;

const ITEMS = [
  { text: <span><ItemAccent>OAuth 2.0</ItemAccent> authentication</span> },
  { text: <span>Read-only <ItemAccent>by default</ItemAccent></span> },
  { text: <span><ItemAccent>Revoke</ItemAccent> access anytime</span> },
];

export default function SecuritySection() {
  return (
    <Section>
      <ScrollReveal>
        <Bar>
          {ITEMS.map((item, i) => (
            <Item key={i}>
              <ItemLabel>{item.text}</ItemLabel>
            </Item>
          ))}
        </Bar>
      </ScrollReveal>
    </Section>
  );
}
